import { render } from "./TheProfile.vue?vue&type=template&id=d5da372c&scoped=true"
import script from "./TheProfile.vue?vue&type=script&lang=js"
export * from "./TheProfile.vue?vue&type=script&lang=js"

import "./TheProfile.vue?vue&type=style&index=0&id=d5da372c&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5da372c"]])

export default __exports__